import { parseDataAttributes } from '../../utilities/utilities'
import type { ButtonConfig } from '../../types/widget-types'

export type QuickOrderConfigStyles = {
  submitButtonVariant?: ButtonConfig
  clearButtonVariant?: ButtonConfig
}

export type QuickOrderAttributes = {
  configStyles?: QuickOrderConfigStyles
}

/**
 * Parse Quick Order widget data attributes from the Elementor-rendered root element.
 */
export function getQuickOrderAttributes(attrs: NamedNodeMap): QuickOrderAttributes {
  const base = parseDataAttributes(attrs) as Record<string, unknown>

  return {
    configStyles: base.configStyles as QuickOrderConfigStyles | undefined,
  }
}

export default function propsFn(dataAttributes: NamedNodeMap): QuickOrderAttributes {
  return getQuickOrderAttributes(dataAttributes)
}
